module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    directives: [{
      name: "modal-show",
      rawName: "v-modal-show",
      value: (_vm.display),
      expression: "display"
    }]
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "M_wrap M_info M_btn_1"
  }, [_c('p', {
    staticClass: "M_title T_18_25 T_b"
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "M_cont",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "M_btns cf"
  }, [_c('a', {
    class: 'M_btn T_w ' + _vm.$style.cssBtnColor,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.modalConfirm))])]), _vm._v(" "), _c('a', {
    staticClass: "M_close I_n",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a13c5da8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/v2/components/common/ConfirmModal.vue
// module id = 524
// module chunks = 142